import type { RoomRate } from '../types/rooms';

/**
 * API responses may encode a rate date as YYYY-MM-DD or as an ISO timestamp.
 * The check-in form uses a date-only value, so compare normalized calendar
 * dates rather than the raw strings.
 */
export function normalizeRateDate(value?: string): string {
  return (value || '').slice(0, 10);
}

export function findMatchingRoomRate(
  rates: RoomRate[],
  roomType: string,
  roomTypeId: string | undefined,
  checkInDate: string,
): RoomRate | undefined {
  const normalizedRoomType = roomType.toLowerCase();
  const normalizedCheckInDate = normalizeRateDate(checkInDate);

  return [...rates]
    .filter((rate) => {
      const typeMatches = rate.room_type_id === roomTypeId
        || (rate.room_type_name || '').toLowerCase() === normalizedRoomType;

      return rate.is_active
        && typeMatches
        && normalizeRateDate(rate.start_date) <= normalizedCheckInDate
        && normalizeRateDate(rate.end_date) >= normalizedCheckInDate;
    })
    .sort((a, b) => {
      const aUpdated = new Date(a.updated_at || a.created_at).getTime();
      const bUpdated = new Date(b.updated_at || b.created_at).getTime();
      return bUpdated - aUpdated;
    })[0];
}
